import { render, staticRenderFns } from "./OrderDelivery.vue?vue&type=template&id=133d1179&scoped=true&"
import script from "./OrderDelivery.vue?vue&type=script&lang=js&"
export * from "./OrderDelivery.vue?vue&type=script&lang=js&"
import style0 from "./OrderDelivery.vue?vue&type=style&index=0&id=133d1179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d1179",
  null
  
)

export default component.exports